import request from 'assets/js/http';

export function reportList(data) {
  // 列表查询
  return request({
    url: '/report/list',
    method: 'post',
    data
  });
}

export function setAuth(data) {
  // 设置权限
  return request({
    url: '/report/setAuth',
    method: 'post',
    data
  });
}

export function queryList(data) {
  // 投资业绩表查询
  return request({
    url: '/dataService/reportForm/investPerformance/queryList',
    method: 'post',
    data
  });
}

export function download(data) {
  // 投资业绩表导出
  return request({
    url: '/dataService/reportForm/investPerformance/download',
    method: 'post',
    responseType: 'blob',
    data
  });
}

export function middlePageList(data) {
  // 中间页数据报表查询
  return request({
    url: '/dataService/reportForm/middlePageData/queryList',
    method: 'post',
    data
  });
}
export function downloadTaskcheckTask(id) {
  return request({
    url: '/dataService/download-task/checkTask',
    method: 'get',
    params: {
      id: id
    }
  });
}
export function creatDownloadTask(data) {
  return request({
    url: '/dataService/reportForm/middlePageData/download',
    method: 'post',
    data: data
  });
}

export function qualityDataList(data) {
  // 品质表数据报表查询
  return request({
    url: '/quality/report/list',
    method: 'post',
    data
  });
}
